module.exports = __webpack_public_path__ + "img/VERTEBRA.ef0f13ee.svg";